module.exports = __webpack_public_path__ + "static/media/pay_nav.d5ad9554.svg";